export const getTopOffsetInvalidControl = (control: HTMLElement): number => {
  const headerOffset = document.querySelector('.header-internet')?.clientHeight ?? 0;
  return (control.parentElement ?? control).getBoundingClientRect().top + window.scrollY - headerOffset;
};

export const scrollInvalidControl = (control: HTMLElement): void => {
  const firstInvalidControl = Array.prototype.filter.call(control
    .querySelectorAll('.input .ng-invalid, .input_radio .ng-invalid, .input_checkbox .ng-invalid, .custom_select .ng-invalid, .custom_selection .ng-invalid' +
      ', .input-file.file-error, .mat-form-field-invalid'),
    function (el) {
      return el.offsetParent !== null;
    }).map(function (el) {
      return el;
    })[0];
  if (firstInvalidControl) {
    window.scroll({
      top: getTopOffsetInvalidControl(firstInvalidControl),
      left: 0,
      behavior: 'smooth'
    });
  }
};

export const getTopOffset = (control: HTMLElement): number => {
  const headerOffset = document.querySelector('.header-internet')?.clientHeight ?? 0;
  return control.getBoundingClientRect().top + window.scrollY - headerOffset;
};

export const scrollControl = (control: HTMLElement): void => {
  if (control) {
    window.scrollTo({
      top: getTopOffset(control),
      left: 0,
      behavior: 'smooth'
    });
  }
};
